import React from 'react'
import '../CSS/Counselling.css'

const Counselling = () => {
    return (
        <div className='Counselling_container'>
            <div className="inner_ConDiv1" id='services'>
                <div className="inner_ConDiv2">
                    <img src="https://serefe.s3.amazonaws.com/media/service/2.png" alt="" />
                    <img src="https://serefe.s3.amazonaws.com/media/service/14.png" alt="" />
                    <img src="https://serefe.s3.amazonaws.com/media/service/4.png" alt="" />
                    <img src="https://serefe.s3.amazonaws.com/media/service/3.png" alt="" />

                    <img src="https://serefe.s3.amazonaws.com/media/service/1.png" alt="" />
                    <img src="https://serefe.s3.amazonaws.com/media/service/5.png" alt="" />
                    <img src="https://serefe.s3.amazonaws.com/media/service/6.png" alt="" />
                    <img src="https://serefe.s3.amazonaws.com/media/service/15.png" alt="" />

                    <img src="https://serefe.s3.amazonaws.com/media/service/12.png" alt="" />
                    <img src="https://serefe.s3.amazonaws.com/media/service/Website_images-01.png" alt="" />
                    <img src="https://serefe.s3.amazonaws.com/media/service/art3-02.png" alt="" />
                    <img src="https://serefe.s3.amazonaws.com/media/service/Website_images-03.png" alt="" />
                </div>
            </div>
            
        </div>
    )
}

export default Counselling
